(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('tipoOrdenService', tipoOrdenService);

	tipoOrdenService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

	function tipoOrdenService($http, $q, endPoints, authorization) {
		var service = {
            getList: getList,
            getById: getById,
            add: add,
            deleteById: deleteById		};

		return service;


        function getList(sorting) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tipoOrden.getList,
                data: { sorting: sorting }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getById(tipoOrdenId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tipoOrden.getById + '?tipoOrdenId=' + tipoOrdenId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function add(obj) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.tipoOrden.add,
                data: {
                    tipoOrdenId: obj.tipoOrdenId,
                    descripcion: obj.descripcion,
                    id : obj.id,
                    entidadId: obj.entidadId,
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function deleteById(objIds) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.tipoOrden.deleteById,
                data: objIds
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

	}

})();